import { createEffect, createMemo, createResource } from "solid-js";
import { isNil } from "lodash-es";
import posthog from "posthog-js";
import { useAuthState } from "../state/auth";
import UserService from "./UserService";
import environment from "../environment";

export const POSTHOG_EVENTS = {
  PREVIEW_OPENED: "form_editor_preview_opened",
  EDITOR_OPENED: "form_editor_opened",
  DRAFT_PUBLISHED: "form_editor_draft_published",
  DRAFT_SAVED: "form_editor_draft_saved",
  FORM_VERSION_RESTORE_REQUIRED: "form_editor_restore_required",
  SUBFORM_NAME_UNCHANGED: "form_editor_subform_name_unchanged",
  SUBFORM_OPENED: "form_editor_subform_opened",
  EDITOR_TOUR_STARTED: "form_editor_tour_started",
  EDITOR_TOUR_SKIPPED: "form_editor_tour_skipped",
  EDITOR_TOUR_COMPLETED: "form_editor_tour_completed",
  EDITOR_TOUR_ABORTED: "form_editor_tour_aborted",
  FORM_CREATED: "form_created",
  LEGACY_PLATFORM_OPENED: "legacy_platform_opened",
  DATA_SOURCE_CREATED: "data_source_created",
  TASK_CREATED: "task_created",
  TASK_CREATION_CANCELED: "task_creation_canceled",
  FOLDER_CREATED: "folder_created",
  USER_INVITED: "user_invited",
  GROUP_CREATED: "group_created",
  ROLE_CREATED: "role_created",
  GLOBAL_SEARCH_RESULT_SELECTED: "global_search_result_selected",
  PAGE_NOT_FOUND: "page_not_found",
} as const;

export const POSTHOG_PROPERTIES = {
  IMPERSONATION: "impersonation",
  CUSTOMER_ID: "customer_id",
  FORM_VERSION_ID: "form_version_id",
} as const;

const init = () => {
  const { loginStatus, impersonation } = useAuthState();
  const [user, { refetch }] = createResource(() => {
    if (loginStatus() === "loggedIn") {
      return UserService.getUser();
    }
  });
  const userId = createMemo(() => user()?.data?.id);

  createEffect(() => {
    if (loginStatus() === "loggedIn") {
      refetch();
    }
  });

  createEffect(() => {
    const id = userId();
    if (loginStatus() === "loggedIn" && !isNil(id)) {
      posthog.identify(id.toString(), { environment: environment.isProduction() ? "production" : "development" });
    } else if (loginStatus() === "loggedOut") {
      posthog.reset();
    }
  });

  createEffect(() => {
    if (impersonation() === undefined) {
      posthog.unregister(POSTHOG_PROPERTIES.IMPERSONATION);
    } else {
      posthog.register({ [POSTHOG_PROPERTIES.IMPERSONATION]: true });
    }
  });
};

export default { init };
